/**
 *
 * AssignAndVideo
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import TwoColumns from 'components/layout/TwoColumns/index.js';
import useVideoEnabled from 'components/VideoConf/useVideoEnabled.js';
import { useSentryContext } from 'utils/sentry.js';
import Blocks from './Blocks.jsx';
import Overview from './Overview.jsx';
import VideoConferences from './VideoConferences.jsx';
import messages from './messages.js';
import ActionButtons from '../ActionButtons/index.jsx';
import useUpdateMeeting from '../../hooks/useUpdateMeeting.js';

function AssignAndVideo(props) {
  const { onNext, meetingSet } = props;
  useSentryContext('meetingSet', meetingSet);
  const handleChange = useUpdateMeeting();
  const [videoEnabled] = useVideoEnabled();
  const intro = videoEnabled ? messages.assignVideoHelp : messages.assignHelp;
  const allProps = {
    ...props,
    onChange: handleChange,
  };
  return (
    <>
      <p className="form-text"><FormattedMessage {...intro} /></p>
      {videoEnabled ? (
        <TwoColumns responsive>
          <Overview {...allProps} />
          <VideoConferences {...allProps} />
        </TwoColumns>
      ) : (
        <Overview {...allProps} />
      )}
      <Blocks {...allProps} />
      <ActionButtons onSubmit={onNext} />
    </>
  );
}

AssignAndVideo.propTypes = {
  meetingSet: PropTypes.object,
  onNext: PropTypes.func,
};

export default AssignAndVideo;
